<!-- <app-theme></app-theme> -->
<router-outlet></router-outlet>
@if (authService.isLoggedIn) {
  <app-chat-widget></app-chat-widget>
}
@if (!!authService.isScionEnv) {
  <cookie-component></cookie-component>
}

<app-modal-opener></app-modal-opener>

@if ({ loading: basketService.addingToBasket | async }; as data) {
  @if (data.loading) {
    <app-loading-screen>
      @if (!displayItinerary) {
        <span title i18n="@@basket_adding_item">Adding item to the basket...</span>
      }
      @if (displayItinerary) {
        <span title i18n="@@basket_adding_item_itinerary">Adding item to the itinerary...</span>
      }
    </app-loading-screen>
  }
}

@if ({ loading: basketService.creatingNewBasket | async }; as data) {
  @if (data.loading) {
    <app-loading-screen>
      @if (!displayItinerary) {
        <span title i18n="@@basket_creating_basket">Creating new basket...</span>
      }
      @if (displayItinerary) {
        <span title i18n="@@basket_creating_basket_itinerary">Creating new itinerary...</span>
      }
    </app-loading-screen>
  }
}

@if ({ loading: basketService.removingFromBasket | async }; as data) {
  @if (data.loading) {
    <app-loading-screen>
      @if (!displayItinerary) {
        <span title i18n="@@basket_loading_title_remove">Removing item from the basket...</span>
      }
      @if (displayItinerary) {
        <span title i18n="@@basket_loading_title_remove_itinerary"
          >Removing item from the itinerary...</span
        >
      }
    </app-loading-screen>
  }
}

@if ({ loading: searchService.gettingFlightClasses | async }; as data) {
  @if (data.loading) {
    <app-loading-screen>
      <span title i18n="@@basket_loading_title_get"> Getting flight classes... </span>
    </app-loading-screen>
  }
}
@if ({ loading: searchService.repricingFlight | async }; as data) {
  @if (data.loading) {
    <app-loading-screen>
      <span title i18n="@@basket_loading_title_reprice"> Repricing Flight... </span>
    </app-loading-screen>
  }
}
@if (displayScrollButton) {
  <button (click)="scrollToTop()" aria-label="Scroll back to top" class="scrolltop_button">
    <i class="ico-chevron-up"></i>
  </button>
}
